import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import { Autoplay } from "swiper/modules";
import "./OurPartners.css"; 

const partners = [
  { name: "TVS", logo: "/tvs.png" },
  { name: "HAL", logo: "/hal.png" },
  { name: "HONDA", logo: "/honda.png" },
  { name: "BLISS", logo: "/bliss.png" },
  { name: "PAC", logo: "/pac.jpg" },
];

const OurPartners = () => {
  return (
    <div className="our-partners-section">
      <h2 className="section-title">Our Top Clients</h2>

      <Swiper
        slidesPerView={2}
        spaceBetween={20}
        loop={true}
        autoplay={{
          delay: 2000,
          disableOnInteraction: false,
        }}
        modules={[Autoplay]}
        className="partners-swiper"
        breakpoints={{
          640: { slidesPerView: 2 },
          768: { slidesPerView: 3 },
          1024: { slidesPerView: 4 },
        }}
      >
        {partners.map((partner, index) => (
          <SwiperSlide key={index}>
            <div className="partner-card">
              <img
                src={partner.logo}
                alt={partner.name}
                className="partner-logo"
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default OurPartners;
